import type { IconData } from '@stacksjs/iconify-core'

export const jp4x3: IconData = {
  "body": "<defs><clipPath id=\"SVG0TFcTbeI\"><path fill-opacity=\".7\" d=\"M-88 32h640v480H-88z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVG0TFcTbeI)\" transform=\"translate(88 -32)\"><path fill=\"#fff\" d=\"M-128 32h720v480h-720z\"/><circle cx=\"523.1\" cy=\"344.1\" r=\"194.9\" fill=\"#bc002d\" transform=\"translate(-168.4 8.6)scale(.76554)\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default jp4x3
